import {SET_TABLE_SUCCESS} from 'new-constants/api.constants';
import {TableNumberState} from './table-number.reducer.types';

export const defaultTableNumberCacheEntry = {table: undefined, timestamp: undefined};

const initialState: TableNumberState = {
	cache: {},
};

export const tableNumberReducer = (previousState = initialState, action): TableNumberState => {
	switch (action && action.type) {
		case SET_TABLE_SUCCESS:
			return {
				...previousState,
				cache: {
					...previousState.cache,
					[action.payload.restaurantId]: {
						table: action.payload.tableNumber,
						timestamp: Date.now(),
					},
				},
			};

		default:
			return previousState;
	}
};
